export default __webpack_public_path__ + "static/media/ed4.34cc305a.svg";